// extracted by mini-css-extract-plugin
export default {"wraper":"Register_wraper__r5KJh","welcome-img":"Register_welcome-img__19nct","form-group":"Register_form-group__1yfHM"};